import { WidgetDataSourceEntity } from '@ardoq/api-types';
import { fetchEntities } from './api';

export const datasourceApi = {
  fetchAll: fetchEntities<WidgetDataSourceEntity>('datasource/v2'),
};
